export class Menu {
  constructor(id, patient, schema) {
    this._id = id;
    this._patient = patient;
    this._schema = schema;
  }

  get id() {
    return this._id;
  }

  get patient() {
    return this._patient;
  }

  get startDate() {
    return this.schema.getFirstDay().date;
  }

  get endDate() {
    return this.schema.getLastDay().date;
  }

  getNumberOfDays() {
    return this.schema.days.length;
  }

  get schema() {
    return this._schema;
  }

  set schema(schema) {
    this._schema = schema;
  }

  toJSON() {
    return {
      id: this.id,
      patient: this.patient,
      startDate: this.startDate / 1000,
      endDate: this.endDate / 1000,
      schema: this.schema,
    };
  }
}
